import React, { useState } from 'react';

const NewGameGroupModal = ({ onClose, onCreate }) => {
  const [name, setName] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    try {
      const response = await fetch('/game_groups.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({ game_group: { name: name, image_url: imageUrl } }),
      });

      const data = await response.json();

      if (response.ok) {
        onCreate(data); // Notify parent to update the game list and close modal
        onClose();
      } else {
        setError(data.errors ? Object.values(data.errors).flat().join(', ') : 'Failed to create group.');
      }
    } catch (error) {
      setError('An unexpected error occurred.');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <article className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header>
          <button aria-label="Close" className="close-button" onClick={onClose}>×</button>
          <h2>Create New Game Group</h2>
        </header>
        {error && <p style={{ color: 'var(--pico-color-red-500)' }}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <label htmlFor="name">Group Name</label>
          <input type="text" id="name" name="name" value={name} onChange={(e) => setName(e.target.value)} required />
          <label htmlFor="image_url">Image URL</label>
          <input
            type="text"
            id="image_url"
            name="image_url"
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
            placeholder="Optional"
          />
          <button type="submit">Create Group</button>
        </form>
      </article>
    </div>
  );
};

export default NewGameGroupModal;